import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.css'],
    standalone: false
})
export class TimeoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
